import { useQuery } from '@tanstack/react-query';
import { m6_2Endpoints } from '../../../endpoints/m6-2';
import { IIndividualAthlete } from '../../../models/m6-2';

/**
 * Lista atleti individuali del coach corrente (M6.2 B11.B).
 * Usato dalla sidebar sezione "Atleti individuali".
 */
export function useIndividualAthletes() {
  return useQuery<IIndividualAthlete[]>({
    queryKey: ['m6-2', 'individual-athletes'],
    queryFn: async () => {
      const res = await m6_2Endpoints.getIndividualAthletes();
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
